import { render, staticRenderFns } from "./ImgOrderList.vue?vue&type=template&id=2308afc0&scoped=true"
import script from "./ImgOrderList.vue?vue&type=script&lang=js"
export * from "./ImgOrderList.vue?vue&type=script&lang=js"
import style0 from "./ImgOrderList.vue?vue&type=style&index=0&id=2308afc0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2308afc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2308afc0')) {
      api.createRecord('2308afc0', component.options)
    } else {
      api.reload('2308afc0', component.options)
    }
    module.hot.accept("./ImgOrderList.vue?vue&type=template&id=2308afc0&scoped=true", function () {
      api.rerender('2308afc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/imgorder/ImgOrderList.vue"
export default component.exports